import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext.js';
import AllPrivateLessons from './AllPrivateLessons.js';
import MyPrivateLessons from './MyPrivateLessons.js';
import './PrivateLessons.css';

function PrivateLessonsHome() {
  const { userInfo } = useAuth();
  const role = userInfo?.role || '';

  const isAdmin = ['super_admin', 'locatie_admin'].includes(role);
  const isTeacher = role === 'docent';

  if (!isAdmin && !isTeacher) {
    return (
      <div className="bg-white p-4">
        <h2 className="text-center">Geen toegang</h2>
        <p className="text-center text-muted">
          Je hebt geen toegang tot de privelesmodule.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-white p-4">
      <h2 className="text-center">Privelessen</h2>
      <hr className="seperator" />

      {isAdmin && (
        <>
          <div className="private-home-section">
            <h4 className="private-home-title">Beheer</h4>
            <div className="private-home-grid">
              <Link to="/private-lessons/admin-booking" className="private-home-card">
                <div className="private-home-card-icon">➕</div>
                <h5>Priveles inplannen</h5>
                <p>Plan direct een bevestigde priveles voor een leerling en gekoppelde docent.</p>
                <span className="private-home-card-action">Openen →</span>
              </Link>

              <Link to="/private-lesson-teacher-links" className="private-home-card">
                <div className="private-home-card-icon">🔗</div>
                <h5>Docenten koppelen</h5>
                <p>Koppel leerlingen aan privelesdocenten en vakken.</p>
                <span className="private-home-card-action">Openen →</span>
              </Link>

              <Link to="/private-lesson-availability" className="private-home-card">
                <div className="private-home-card-icon">🕒</div>
                <h5>Beschikbaarheid docenten</h5>
                <p>Beheer beschikbaarheid en uitzonderingen van docenten.</p>
                <span className="private-home-card-action">Openen →</span>
              </Link>
            </div>
          </div>

          <div className="private-home-section">
            <AllPrivateLessons embedded title="Alle privelessen" />
          </div>
        </>
      )}

      {isTeacher && (
        <>
          <div className="private-home-section">
            <h4 className="private-home-title">Mijn werk</h4>
            <div className="private-home-grid">
              <Link to="/docent/private-lesson-availability" className="private-home-card">
                <div className="private-home-card-icon">🕒</div>
                <h5>Mijn beschikbaarheid</h5>
                <p>Beheer je standaard beschikbaarheid en uitzonderingen.</p>
                <span className="private-home-card-action">Openen →</span>
              </Link>
            </div>
          </div>

          <div className="private-home-section">
            <MyPrivateLessons embedded title="Mijn privelessen" />
          </div>
        </>
      )}
    </div>
  );
}

export default PrivateLessonsHome;
